


import React from 'react';
import './index.scss';
import ComTitle from '@/components/comTitle';
function Meth({
    info
}) {
    return (
        <div className='home-meth'>
            <ComTitle title='任务攻略' />
            {info.map((it, idx) => 
                <div className='meth-box' key={idx}>
                    <img 
                    className='meth-bg-img1'
                    src='https://img12.360buyimg.com/imagetools/jfs/t1/168742/5/19042/4199/60796100E4b5d247d/354829babed32637.png' />
                    <img 
                    className='meth-bg-img2'
                    src='https://img12.360buyimg.com/imagetools/jfs/t1/164685/31/18922/2363/60796104Eae14c4c5/9fb822bb1dcbd8de.png' />
                    
                    <div className='meth-box-content'>
                        <p>{it.title}</p>
                        <div>{it.content}</div>
                    </div>
                </div>
            )}
            
        </div>
    )
}

export default React.memo(Meth);